module.exports = __webpack_public_path__ + "static/media/frank.5dd8899e.JPEG";